"use client";

import { useSite } from "@/lib/hooks/site";
import { useState } from "react";
import VenueCardNoImg from "../list/card/VenueCardNoImg";
import S3Image from "@/components/S3Image";

interface Props {
  count: number;
  image: string;
  title: string;
}

export default function Card(props: Props) {
  const site = useSite();
  const [error, setError] = useState(false);
  return (
    <div className="p-4 rounded-[24px] bg-white shadow-md flex flex-col gap-4  justify-center w-full md:w-[285px] h-[326px]">
      <div className="relative">
        <div className="absolute top-0 left-6 -translate-y-[22px] border-4 border-white flex justify-center items-center rounded-2xl bg-[#15BBAE] text-white font-bold text-xl w-[48px] h-[48px]">
          {props.count}
        </div>
        {!props.image || error ? (
          <div className="rounded-2xl object-cover object-center w-full h-[204px]">
            <VenueCardNoImg type={0} />
          </div>
        ) : (
          <S3Image
            src={props.image}
            width={204}
            height={204}
            alt={`${site.descriptions[0]?.title} ~ ${props.title}`}
            className="rounded-2xl object-cover object-center w-full h-[204px]"
            onError={() => setError(true)}
          />
        )}
      </div>

      <h3 className="font-bold text-primary text-xl">{props.title}</h3>
    </div>
  );
}
